import { RiskAppetite } from "@portal/types/robot/IRobotEnums";

export const MapIndexToRiskAppetite = (selectedItem: number | null) => {
  if (selectedItem === 0) return null;
  if (selectedItem === 1) return RiskAppetite.Careful;
  if (selectedItem === 2) return RiskAppetite.Balanced;
  if (selectedItem === 3) return RiskAppetite.Offensive;
  return null;
};

export const MapRiskAppetiteToIndex = (requestResult: RiskAppetite | null) => {
  if (requestResult === RiskAppetite.Careful) return 1;
  if (requestResult === RiskAppetite.Balanced) return 2;
  if (requestResult === RiskAppetite.Offensive) return 3;
  return null;
};
